module.exports = __webpack_public_path__ + "img/bb14b03.jpg";